// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textcolor {
  color: #5ea1d8;
}

p {
  margin: 0px;
}

.zoom {
  cursor: pointer;
  width: 100%;
  height: 70%;
  transition: transform 0.1s;
  border-radius: 8px;
}

.zoom:hover {
  transform: scale(1);
  overflow: hidden;
  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}

.zoom:hover img {
  transform: scale(1.2);
  transition: all 0.5s linear;
}

.owl-carousel .owl-nav button.owl-next,
.owl-carousel .owl-nav button.owl-prev,
.owl-carousel button.owl-dot {
  font-size: 55px !important;
}

.owl-theme .owl-nav [class*=owl-] {
  font-size: 55px !important;
}

button span {
  font-size: 55px;
}

.owl-nav {
  display: none;
}

.with-icon {
  display: flex;
}

.carousel-wrap {
  width: 1000px;
  margin: auto;
  position: relative;
}

.owl-carousel .owl-nav {
  overflow: hidden;
  height: 0px;
}

.owl-theme .owl-dots .owl-dot.active span,
.owl-theme .owl-dots .owl-dot:hover span {
  background: #2caae1;
}

.owl-carousel .item {
  text-align: left;
  background: #fff;
}

.owl-carousel .nav-btn {
  height: 47px;
  position: absolute;
  width: 26px;
  cursor: pointer;
  top: 100px !important;
}

.owl-carousel .owl-prev.disabled,
.owl-carousel .owl-next.disabled {
  pointer-events: none;
  opacity: 0.2;
}

.owl-carousel .prev-slide {
  left: -33px;
}

.owl-carousel .next-slide {
  right: -33px;
}

.owl-carousel .prev-slide:hover {
  background-position: 0px -53px;
}

.owl-carousel .next-slide:hover {
  background-position: -24px -53px;
}

span.img-text {
  text-decoration: none;
  outline: none;
  transition: all 0.4s ease;
  -webkit-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  cursor: pointer;
  width: 100%;
  font-size: 23px;
  display: block;
  text-transform: capitalize;
}

span.img-text:hover {
  color: #2caae1;
}

.mat-badge-content {
  background: red;
}

.div1 {
  height: 50px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: white;
  overflow: hidden;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.notify {
  color: grey;
}

.notify:hover {
  color: #5ea1d8;
}

.notify:active {
  color: #5ea1d8;
}

.notify:focus {
  color: #5ea1d8;
}

#fab-dismiss {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}

.fab-container {
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 100;
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
}
.fab-container > div {
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  margin-bottom: 5px;
}
.fab-container > div button {
  margin-bottom: 17px;
}

.fab-toggler {
  float: right;
  z-index: 100;
}

/*my scss add*/
@media (max-width: 767px) {
  .sample-add .mat-drawer-content {
    padding: 0px 0px 0px 15px !important;
  }
  .sample-add .owl-carousel.owl-drag .owl-item {
    width: 11% !important;
  }
}
.bundleIcon {
  bottom: 10px;
  right: 10px;
  z-index: 10;
  width: 25px;
  height: 25px;
}
.bundleIcon img {
  width: 100% !important;
  height: auto !important;
  object-fit: contain;
  border: none;
}

@media (max-width: 767px) {
  .sample-add .mat-drawer-content {
    padding: 0px 0px 0px 15px !important;
  }
  .sample-add .owl-carousel.owl-drag .owl-item {
    width: 11% !important;
  }
}
.user-pro .item .with-icon img {
  width: 30px !important;
  height: 30px !important;
  border-radius: 50% !important;
  margin: 0px !important;
}

.uni-wrapper {
  display: flex;
  width: 100%;
  align-items: center;
}
.uni-wrapper P {
  flex: 1;
}

.example-container .mat-sidenav-content {
  padding-top: 0px !important;
}
.example-container h3 {
  margin-bottom: 0px !important;
}

.foot-ico ul li {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.foot-ico ul li span {
  text-align: center;
  display: block;
  width: 100%;
  text-align: center;
}
.foot-ico ul li .icon-text {
  text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);
  font-size: 12px;
  color: gray;
  display: block;
  text-align: center;
  font-family: "Raleway" !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/sample/sample.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAaA;EACE,WAAA;AAVF;;AAaA;EACE,eAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,kBAAA;AAVF;;AAaA;EAIE,mBAAA;EACA,gBAAA;EAEA,qFAAA;AAdF;;AAgBA;EACE,qBAAA;EACA,2BAAA;AAbF;;AAgBA;;;EAGE,0BAAA;AAbF;;AAgBA;EACE,0BAAA;AAbF;;AAgBA;EACE,eAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAiBA;EACE,aAAA;EACA,YAAA;EACA,kBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,WAAA;AAdF;;AAiBA;;EAEE,mBAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;AAdF;;AAiBA;;EAEE,oBAAA;EACA,YAAA;AAdF;;AAiBA;EAEE,WAAA;AAfF;;AAkBA;EAEE,YAAA;AAhBF;;AAmBA;EACE,8BAAA;AAhBF;;AAmBA;EACE,gCAAA;AAhBF;;AAmBA;EACE,qBAAA;EACA,aAAA;EACA,yBAAA;EACA,iCAAA;EACA,8BAAA;EACA,4BAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,0BAAA;AAhBF;;AAmBA;EACE,cAAA;AAhBF;;AAmBA;EACE,eAAA;AAhBF;;AAmBA;EACE,YAAA;EAEA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAjBF;;AAoBA;EACE,WAAA;AAjBF;;AAmBA;EACE,cAAA;AAhBF;;AAkBA;EACE,cAAA;AAfF;;AAiBA;EACE,cAAA;AAdF;;AAqBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;AAlBF;;AAqBA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAlBF;AAoBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,mBAAA;AAlBN;;AAuBA;EACE,YAAA;EACA,YAAA;AApBF;;AAuBA,cAAA;AAeA;EAEI;IACE,oCAAA;EAnCJ;EAqCE;IACE,qBAAA;EAnCJ;AACF;AAuCA;EAEE,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;AAtCF;AAuCE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AArCJ;;AAwCA;EAEI;IACE,oCAAA;EAtCJ;EAwCE;IACE,qBAAA;EAtCJ;AACF;AAyCA;EACE,sBAAA;EACA,uBAAA;EACA,6BAAA;EACA,sBAAA;AAvCF;;AA0CA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AAvCF;AAwCE;EACE,OAAA;AAtCJ;;AA0CE;EACE,2BAAA;AAvCJ;AAyCE;EACE,6BAAA;AAvCJ;;AA2CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAxCF;AAyCE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AAvCJ;AAyCE;EACE,iDAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;EAEA,kBAAA;EACA,iCAAA;AAxCJ","sourcesContent":[".textcolor {\n  color: #5ea1d8;\n}\n\n// .item {\n//   border: solid 0.5px lightgrey;\n//   margin: 5px;\n//   width: 170px;\n// }\n\n.item .img {\n  // height: 150px !important;\n  // margin: 5px;\n}\n\np {\n  margin: 0px;\n}\n\n.zoom {\n  cursor: pointer;\n  width: 100%;\n  height: 70%;\n  transition: transform 0.1s;\n  border-radius: 8px;\n}\n\n.zoom:hover {\n  // border-radius: 5px;\n  // -ms-transform: scale(1.2); /* IE 9 */\n  // -webkit-transform: scale(1.5); /* Safari 3-8 */\n  transform: scale(1);\n  overflow: hidden;\n\n  /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */\n}\n.zoom:hover img {\n  transform: scale(1.2);\n  transition: all 0.5s linear;\n}\n\n.owl-carousel .owl-nav button.owl-next,\n.owl-carousel .owl-nav button.owl-prev,\n.owl-carousel button.owl-dot {\n  font-size: 55px !important;\n}\n\n.owl-theme .owl-nav [class*=\"owl-\"] {\n  font-size: 55px !important;\n}\n\nbutton span {\n  font-size: 55px;\n}\n\n.owl-nav {\n  display: none;\n}\n\n.with-icon {\n  display: flex;\n  //align-items: center;\n}\n\n.carousel-wrap {\n  width: 1000px;\n  margin: auto;\n  position: relative;\n}\n\n.owl-carousel .owl-nav {\n  overflow: hidden;\n  height: 0px;\n}\n\n.owl-theme .owl-dots .owl-dot.active span,\n.owl-theme .owl-dots .owl-dot:hover span {\n  background: #2caae1;\n}\n\n.owl-carousel .item {\n  text-align: left;\n  background: #fff;\n}\n\n.owl-carousel .nav-btn {\n  height: 47px;\n  position: absolute;\n  width: 26px;\n  cursor: pointer;\n  top: 100px !important;\n}\n\n.owl-carousel .owl-prev.disabled,\n.owl-carousel .owl-next.disabled {\n  pointer-events: none;\n  opacity: 0.2;\n}\n\n.owl-carousel .prev-slide {\n  //background: url(nav-icon.png) no-repeat scroll 0 0;\n  left: -33px;\n}\n\n.owl-carousel .next-slide {\n  //background: url(nav-icon.png) no-repeat scroll -24px 0px;\n  right: -33px;\n}\n\n.owl-carousel .prev-slide:hover {\n  background-position: 0px -53px;\n}\n\n.owl-carousel .next-slide:hover {\n  background-position: -24px -53px;\n}\n\nspan.img-text {\n  text-decoration: none;\n  outline: none;\n  transition: all 0.4s ease;\n  -webkit-transition: all 0.4s ease;\n  -moz-transition: all 0.4s ease;\n  -o-transition: all 0.4s ease;\n  cursor: pointer;\n  width: 100%;\n  font-size: 23px;\n  display: block;\n  text-transform: capitalize;\n}\n\nspan.img-text:hover {\n  color: #2caae1;\n}\n\n.mat-badge-content {\n  background: red;\n}\n\n.div1 {\n  height: 50px;\n  //border: 1px solid blue;\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: white;\n  overflow: hidden;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.notify {\n  color: grey;\n}\n.notify:hover {\n  color: #5ea1d8;\n}\n.notify:active {\n  color: #5ea1d8;\n}\n.notify:focus {\n  color: #5ea1d8;\n}\n\nimg {\n  // border-radius: 50%;\n}\n\n#fab-dismiss {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 99;\n}\n\n.fab-container {\n  position: fixed;\n  bottom: 15px;\n  right: 15px;\n  z-index: 100;\n  display: flex;\n  flex-direction: column-reverse;\n  align-items: center;\n\n  > div {\n    display: flex;\n    flex-direction: column-reverse;\n    align-items: center;\n    margin-bottom: 5px;\n\n    button {\n      margin-bottom: 17px;\n    }\n  }\n}\n\n.fab-toggler {\n  float: right;\n  z-index: 100;\n}\n\n/*my scss add*/\n\n// .img-div-left{\n//   position: fixed;\n//   z-index: 999;\n//   height: 150px;\n//   width: 150px;\n//   overflow: visible;\n//   margin: auto;\n//   top: 0;\n//   left: 0;\n//   bottom: 0;\n//   right: 0;\n// }\n\n@media (max-width: 767px) {\n  .sample-add {\n    .mat-drawer-content {\n      padding: 0px 0px 0px 15px !important;\n    }\n    .owl-carousel.owl-drag .owl-item {\n      width: 11% !important;\n    }\n  }\n}\n\n.bundleIcon {\n  // position: absolute;\n  bottom: 10px;\n  right: 10px;\n  z-index: 10;\n  width: 25px;\n  height: 25px;\n  img{\n    width: 100% !important;\n    height: auto !important;\n    object-fit: contain;\n    border: none;\n  }\n}\n@media (max-width: 767px) {\n  .sample-add {\n    .mat-drawer-content {\n      padding: 0px 0px 0px 15px !important;\n    }\n    .owl-carousel.owl-drag .owl-item {\n      width: 11% !important;\n    }\n  }\n}\n.user-pro .item .with-icon img {\n  width: 30px !important;\n  height: 30px !important;\n  border-radius: 50% !important;\n  margin: 0px !important;\n}\n\n.uni-wrapper {\n  display: flex;\n  width: 100%;\n  align-items: center;\n  P {\n    flex: 1;\n  }\n}\n.example-container {\n  .mat-sidenav-content {\n    padding-top: 0px !important;\n  }\n  h3 {\n    margin-bottom: 0px !important;\n  }\n}\n\n.foot-ico ul li{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  span{\n    text-align: center;\n    display: block;\n    width: 100%;\n    text-align: center;\n  }\n  .icon-text{\n    text-shadow: 0px 2px 2px rgba(186, 183, 183, 0.4);\n    font-size: 12px;\n    color: gray;\n    display: block;\n    // width: 80px;\n    text-align: center;\n    font-family: \"Raleway\" !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
